import React from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import { NextImage } from '@/components/NextImage'
import { useTranslation } from '@/localization/useTranslation'
import { TEAM_ROUTES } from '@/utils/routes'
import buttonClasses from '@/components/Buttons/Button/styles.module.scss'

import classes from '../styles.module.scss'

interface FavoriteTeamButtonProps {
  iconSrc: string
  iconAlt?: string
}

export const FavoriteTeamButton: React.FC<FavoriteTeamButtonProps> = ({ iconSrc, iconAlt }) => {
  const { t } = useTranslation()

  return (
    <Link
      id="favorite-team"
      href={TEAM_ROUTES.favoriteTeam}
      className={classNames(buttonClasses.button, buttonClasses.tertiary, buttonClasses.sm, classes.favoriteTeamButton)}
      data-testid="component-navbar-favorite-team-button"
    >
      {t('Favorite Team')}
      <NextImage src={iconSrc} alt={iconAlt || ''} width={16} height={16} />
    </Link>
  )
}
